// UI-side role gating. RLS is the source of truth — this layer prevents
// users from seeing buttons/views they cannot use.

import type { AuthApi } from '../auth';
import type { Role } from '../db/types';

export function hasAnyRole(auth: AuthApi, roles: Role[]): boolean {
  return roles.includes(auth.getRole());
}

export function renderDeniedView(container: HTMLElement, message: string): void {
  container.innerHTML = `
    <div class="view-help" style="background:rgba(204,102,119,0.1);border-left-color:var(--q-iif);">
      <strong>Akses ditolak.</strong> ${escapeHtml(message)}
    </div>
  `;
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function applyNavVisibility(roleOf: () => Role, viewRoles: Record<string, Role[]>): void {
  const role = roleOf();
  document.querySelectorAll<HTMLElement>('.studio-nav-item').forEach((btn) => {
    const v = btn.dataset.view ?? '';
    const allowed = viewRoles[v]?.includes(role) ?? false;
    btn.style.display = allowed ? '' : 'none';
  });
}
